export default ".options-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n}";